<template>
  <main class="main-tag">
    <div
      class="login-page"
      id="login-page"
      style="display: none"
      :class="isVind ? 'login-page-default' : 'login-page-portals'"
    >
      <div
        class="background-img"
        v-if="!isVind"
        :class="isSKS ? 'sks-bg' : ''"
      ></div>

      <div class="q-pa-md" v-if="!isVind">
        <ErrorModal v-if="hasModalError" />
        <q-form
          @submit="onSubmit"
          @reset="onReset"
          class="q-gutter-md login-form row"
        >
          <div>
            <div class="column" style="padding-top: 18px">
              <h4 class="q-mb-md welcome-heading-text">
                Welkom op Vindsubsidies loket {{ customerPortalSignatureName }}
              </h4>
              <p class="sub-welcome-text">
                Vind relevante subsidies door je te registeren
              </p>
            </div>

            <div class="login-field-wrap">
              <q-input
                v-model="user.email"
                bg-color="white"
                :label="t('login.e-mail_address')"
                dense
                borderless
                :rules="[
                  (val) => !!val || t('login.email_validation'),
                  isValidEmail,
                ]"
              />
              <div class="password-fields q-my-md">
                <q-input
                  type="password"
                  bg-color="white"
                  v-model="user.password"
                  :label="t('login.password')"
                  lazy-rules
                  borderless
                  dense
                  :rules="[
                    (val) =>
                      (val && val.length > 5) || t('login.password_validation'),
                  ]"
                />
              </div>
              <div class="password-options">
                <q-checkbox v-model="user.right" :label="t('login.remember')" />
                <router-link
                  :to="{ name: 'ResetPassword' }"
                  class="navmenu-link"
                >
                  <p
                    class="q-mt-md q-ml-md forgot-password"
                    style="color: #131879; text-decoration: underline"
                  >
                    {{ t("login.forgot_password") }}
                  </p>
                </router-link>
              </div>
            </div>
            <div>
              <q-btn
                :label="t('login.log_in')"
                type="submit"
                no-caps
                class="bold-font orange-btn-filled"
              />
            </div>
            <div class="register-btn" v-if="!isVind">
              <p class="create-account">
                <strong> {{ t("login.create_account") }} </strong>
              </p>
              <q-btn
                no-caps
                class="bold-font orange-btn q-mb-md"
                style="max-width: 124px; text-decoration: none"
                :label="t('login.register')"
                :to="{ name: 'Register' }"
              />
            </div>
          </div>
        </q-form>
      </div>
      <div class="q-pa-md" v-else>
        <ErrorModal v-if="hasModalError" />
        <q-form
          v-if="!isLoggedIn"
          @submit="onSubmit"
          @reset="onReset"
          class="q-gutter-md login-form-center row"
        >
          <div>
            <h4>{{ t("login.login") }}</h4>
            <q-input
              v-model="user.email"
              borderless
              :placeholder="t('login.e-mail')"
              bg-color="white"
              class="tb-login"
            />
            <div class="password-fields q-mt-md">
              <q-input
                borderless
                type="password"
                class="tb-login"
                v-model="user.password"
                :placeholder="t('login.password')"
                bg-color="white"
                lazy-rules
                :rules="[
                  (val) =>
                    (val && val.length > 5) || t('login.password_validation'),
                ]"
              />
              <div class="password-options">
                <q-checkbox v-model="user.right" :label="t('login.remember')" />
                <router-link
                  :to="{ name: 'ResetPassword' }"
                  class="navmenu-link"
                >
                  <q-btn
                    no-caps
                    flat
                    :label="t('login.forgot_password')"
                    class="forgot-password"
                  />
                </router-link>
              </div>
            </div>
            <div>
              <q-btn
                :label="t('login.log_in')"
                type="submit"
                class="login-btn bold-font"
                no-caps
                color="#0a1f8f"
              />
            </div>
            <div class="q-mt-lg q-mb-lg text-center">
              <div @click="loginms" class="btn-ms-signin"></div>
            </div>
          </div>

          <div
            class="updates-box"
            v-if="globalSettings != null && globalSettings.showBoxInContent"
          >
            <span
              style="margin-top: 16px"
              v-html="globalSettings.boxTitle"
              align="left"
              class="updates-text updates-heading"
            ></span>
            <span
              v-html="globalSettings.boxContent"
              class="q-mt-sm updates-text updates-content"
              align="left"
            ></span>

            <q-btn
              no-caps
              flat
              :label="globalSettings.releaseNotesButtonLabel"
              class="updates-btn"
              align="left"
              :href="globalSettings.releaseNotesButtonLink"
              target="_blank"
            />

            <q-btn
              no-caps
              flat
              :label="globalSettings.platformUpdatesButtonLabel"
              class="updates-btn"
              align="left"
              :href="globalSettings.platformUpdatesButtonLink"
              target="_blank"
            />

            <q-btn
              no-caps
              flat
              :label="globalSettings.scheduledMaintenanceButtonLabel"
              class="updates-btn"
              style="margin-bottom: 24px"
              align="left"
              :href="globalSettings.scheduledMaintenanceButtonLink"
              target="_blank"
            />
          </div>
        </q-form>
        <q-form
          v-else-if="
            displayCustomerSelection &&
            sasCustomersOptions &&
            sasCustomersOptions.length > 0
          "
          @submit="confirmCustomerSelection"
          @reset="onResetSelectedCustomer"
          class="q-gutter-md login-form-center row"
        >
          <div>
            <h4>{{ t("login.select_customer") }}</h4>
            <div class="row justify-around">
              <q-select
                outlined
                bg-color="white"
                v-model="selectedCustomer"
                :options="sasCustomersOptions"
                option-label="name"
                option-value="id"
                emit-value
                map-options
                :label="t('login.select_customer')"
                stack-label
                behavior="menu"
                style="width: 100%"
                dense
              >
              </q-select>
            </div>
            <div class="password-fields q-mt-md">
              <q-input
                v-if="
                  isLoggedIn === true &&
                  authUser.customerId &&
                  selectedCustomer !== authUser.customerId
                "
                borderless
                type="password"
                class="tb-login"
                v-model="user.password"
                :placeholder="t('login.password')"
                bg-color="white"
                lazy-rules
                :rules="[
                  (val) =>
                    (val && val.length > 5) || t('login.password_validation'),
                ]"
              />
              <div
                v-if="selectedCustomer && selectedCustomer > 0"
                class="password-options"
              >
                <router-link
                  :to="{ name: 'ResetPassword' }"
                  class="navmenu-link"
                >
                  <q-btn
                    no-caps
                    flat
                    :label="t('login.forgot_password')"
                    class="forgot-password"
                  />
                </router-link>
              </div>
            </div>
            <div>
              <q-btn
                v-if="selectedCustomer && selectedCustomer > 0"
                :label="t('login.log_in')"
                type="submit"
                class="login-btn bold-font"
                no-caps
                color="#0a1f8f"
              />
            </div>
          </div>
        </q-form>
        <div class="row justify-around q-pt-md" v-if="!isVind">
          <q-btn
            no-caps
            color="#0a1f8f"
            style="background: #14157e; max-width: 400px; text-decoration: none"
            :label="t('login.sign_up_question')"
            :to="{ name: 'Register' }"
          />
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { computed, reactive, onMounted } from "vue";
import store from "../store/index.js";
import { useRouter, useRoute } from "vue-router";
import ErrorModal from "./ErrorModal.vue";
import authService from "../services/auth.service.js";
import newsService from "../services/news.service";
import moment from "moment";
import { useI18n } from "vue-i18n";

export default {
  components: {
    ErrorModal,
  },
  setup() {
    const user = reactive({
      email: null,
      password: null,
      right: false,
    });

    const { t, locale } = useI18n();

    onMounted(async () => {
      if (isLoggedIn.value == true) {
        await authService.handleLoginRedirect();
      }
      await authService.getEnvironment();
      await authService.getGlobalSettings();
      await authService.getPortalInfo();
      await newsService.getNewsForLoginPage();
    });

    const newsList = computed({
      get: () => store.state.news.latestNewsLoginPage,
    });

    const globalSettings = computed({
      get: () => store.state.globalSettings.settings,
    });

    const router = useRouter();
    const route = useRoute();

    const isLoggedIn = computed({
      get: () => store.state.auth.isLoggedIn,
    });
    const authUser = computed({
      get: () => store.state.auth.authUser,
    });
    const displayCustomerSelection = computed({
      get: () => store.state.auth.customerSelectionEnabled,
    });
    const sasCustomersOptions = computed({
      get: () => store.state.auth.sasCustomersOptions,
    });
    const hasModalError = computed({
      get: () => store.state.auth.hasModalError,
    });

    const loginms = () => {
      authService.loginMsOidc();
    };

    const onSubmit = async () => {
      await authService.login(user, locale);
    };

    const formatDate = (stringDate) => {
      const dateN = new Date(stringDate);
      return moment(dateN).format("DD-MM-YYYY");
    };

    const isVind = computed({
      get: () => store.state.auth.env === 0 || store.state.auth.env === 40,
    });

    const isSKS = computed({
      get: () => store.state.auth.env === 30,
    });

    const customerPortalSignatureName = computed({
      get: () => store.state.auth.customer.customerPortalSignatureName,
    });
    const selectedCustomer = computed({
      get: () => store.state.auth.selectedSasCustomer,
      set: (val) => store.commit("auth/setSelectedSasCustomer", val),
    });

    const confirmCustomerSelection = async () => {
      if (
        isLoggedIn.value === true &&
        selectedCustomer.value &&
        authUser.value.customerId &&
        selectedCustomer.value === authUser.value.customerId
      ) {
        let returnUrl = router.currentRoute.value.query.returnUrl || "";
        store.commit("auth/setSelectedSasCustomer", null);
        location.href =
          returnUrl !== ""
            ? decodeURIComponent(returnUrl)
            : `${process.env.VUE_APP_SAS_BASE_URL}/#${authUser.value.sasDefaultPath}`;
      } else {
        let secondUser = {
          email: authUser.value.email,
          password: user.password,
        };
        store.commit("auth/disableCustomerSelection");
        router.replace({
          query: {
            ...route.query,
            returnUrl: `${process.env.VUE_APP_SAS_BASE_URL}/#${authUser.value.sasDefaultPath}`,
          },
        });
        await authService.login(secondUser, locale, selectedCustomer.value);
      }
    };

    const onResetSelectedCustomer = () => {
      user.email.value = null;
      user.password.value = null;
      selectedCustomer.value = null;
    };

    return {
      globalSettings,
      t,
      locale,
      customerPortalSignatureName,
      formatDate,
      newsList,
      onSubmit,
      router,
      isLoggedIn,
      hasModalError,
      user,
      isVind,
      isSKS,
      loginms,
      displayCustomerSelection,
      sasCustomersOptions,
      selectedCustomer,
      confirmCustomerSelection,
      authUser,
      isValidEmail(val) {
        const emailPattern =
          /^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/;
        return emailPattern.test(val) || t("common.invalid_email_address");
      },
      onReset() {
        user.email.value = null;
        user.password.value = null;
      },
      onResetSelectedCustomer,
    };
  },
};
</script>

<style>
.tb-login .q-field__control {
  height: 40px;
}

.btn-ms-signin {
  background-image: url(https://content.vindsubsidies.nl/css/img/ms-login.svg);
  border: 0;
  background-color: transparent;
  background-size: 100% 100%;
  border: 0;
  width: 200px;
  height: 40px;
  padding: 10px;
  cursor: pointer;
  margin: auto;
}
</style>
